(function($, undefined) {
	
	'use strict';
	var utils;
	var studentForm;
	var schoolForm;
	var formValidator;
	var groupInput;
	
	
	
	var validateStudentFormBeforeSubmit = function() {
		var thisForm = $(this);
		
		var tempUsernameInput = $('[name=usernameTemp]', thisForm);
		var emailInput = $('[name=email]', thisForm);
		var groupInput = $('[name=field3]', thisForm);
		
		emailInput.val(groupInput.val() + utils.getUsernameSeparator() + tempUsernameInput.val());
		
		return validateFormBeforeSubmit(thisForm);
	};
	
	var validateSchoolFormBeforeSubmit = function() {
		return validateFormBeforeSubmit($(this));	
	};
	
	var validateFormBeforeSubmit = function(thisForm) {
		formValidator.validateForm(thisForm);
		
		if (thisForm.hasClass('has-error')) {
			return false;
		}
		return true;	
	};
	
	var updateStudentAjax = function() {
		var btn = $(this);
		var form = btn.closest('form');
		form.addClass('processing');
		
		
		$('.success-msg', form).slideUp();
		$('.error-msg', form).slideUp();
		if (validateFormBeforeSubmit(form)) {
			var action = "/action/csrsAjax";
			var params = {
				"edit": 'true',
				"id": $('input[name=id]', form).val(),
				"lastName": $('input[name=lastName]', form).val(),
				"firstName": $('input[name=firstName]', form).val(),
				"email": $('select[name=field3]', form).val() + utils.getUsernameSeparator() + $('input[name=usernameTemp]', form).val(),
				"field3": $('select[name=field3]', form).val(),
				"field4": $('select[name=field4]', form).val()
			};
			$.ajax({
				url: action,
				method: "post",
				data: params,
				success: function(response) {
					console.log(response);
					
					if (response.indexOf('success') !== -1) {
						$('.success-msg', form).slideDown();
					} else {
						$('.error-msg', form).slideDown();
					}
				},
				complete: function() {
					form.removeClass('processing');
				},
				error: function(jqxhr, status, error) {
					console.log(status + " " + error);
				}
			});
		}
	};
	
	var init = function () {
		utils = Fw.component.models().utils;
		formValidator = Fw.component.models().form;
		studentForm = $('.student-info-form');
		schoolForm = $('.add-school-form');
		
		studentForm.on('submit', validateStudentFormBeforeSubmit);
		schoolForm.on('submit', validateSchoolFormBeforeSubmit);
		
		$('.js-form-btn.ajax', studentForm).on('click', updateStudentAjax);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
